import { useState, useEffect } from "react";
import SEOHead from "@/components/SEOHead";
import { CornerDownRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import contactBg from "@/assets/carbonwize-contact-bg.png";
const BecomePartner = () => {
  const { t, language } = useLanguage();
  const isThai = language === "th";
  const [isLoading, setIsLoading] = useState(true);
  const partnerTypes = [t("partner.type1"), t("partner.type2"), t("partner.type3"), t("partner.type4")];

  const metadata = {
    en: {
      title: "Become a Partner | Carbonwize",
      description: "Partner with Carbonwize to expand your sustainability offerings. Join our network of consultants, auditors, and technology partners.",
      locale: "en_US"
    },
    th: {
      title: "เป็นพาร์ทเนอร์ | Carbonwize",
      description: "ร่วมเป็นพาร์ทเนอร์กับ Carbonwize เพื่อขยายบริการด้านความยั่งยืนของคุณ เข้าร่วมเครือข่ายที่ปรึกษา ผู้ตรวจสอบ และพาร์ทเนอร์ด้านเทคโนโลยี",
      locale: "th_TH"
    }
  };

  const ogTags = {
    title: "Carbonwize | Audit-Grade Carbon Management for Enterprises",
    description: "Automate carbon accounting with enterprise-grade compliance, precision, and automation. Trusted by 500+ enterprises."
  };

  useEffect(() => {
    // Load Pipedrive script dynamically
    const script = document.createElement("script");
    script.src = "https://webforms.pipedrive.com/f/loader";
    script.async = true;
    document.body.appendChild(script);

    // Show loading for 1.5s to allow form to load
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return <>
      <SEOHead
        title={metadata[language].title}
        description={metadata[language].description}
        path="/become-partner"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://carbonwize.io"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Become a Partner",
              "item": "https://carbonwize.io/become-partner"
            }
          ]
        }}
      />

      <Navbar />

      <main className="min-h-screen pt-[65px]" style={{
      backgroundColor: '#024241'
    }}>
        {/* Hero Section with Form */}
        <section className="relative overflow-hidden min-h-[calc(100vh-65px)] flex items-center" style={{
        backgroundImage: `url(${contactBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}>
          <div className="container mx-auto px-3 sm:px-4 lg:px-8 py-8 lg:py-12">
            <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-12 items-center">
              {/* Left Content */}
              <div className="relative z-10">
                <h1 className={`font-bold text-white mb-4 ${isThai ? "text-3xl lg:text-4xl" : "text-4xl lg:text-5xl"}`}>
                  {t("partner.title")}
                </h1>
                
                <p className={`text-white/80 mb-5 max-w-xl ${isThai ? "text-base lg:text-lg" : "text-lg lg:text-xl"}`}>
                  {t("partner.description")}
                </p>

                {/* Partner Types */}
                <div className="space-y-3 mb-6">
                  {partnerTypes.map((type, index) => <div key={index} className="flex items-center gap-3">
                      <CornerDownRight className="w-5 h-5 text-primary flex-shrink-0" />
                      <span className="text-white text-lg">{type}</span>
                    </div>)}
                </div>

                <p className="text-white text-lg">
                  {t("partner.formNote")}
                </p>
              </div>

              {/* Right - Partner Form */}
              <div className="relative z-10 flex justify-center lg:justify-start">
                <div className="bg-card rounded-2xl p-4 sm:p-6 lg:p-8 shadow-xl border border-border min-h-[400px] relative w-full sm:w-[500px]">
                  {/* Loading overlay - shown on top */}
                  {isLoading && <div className="absolute inset-0 flex flex-col items-center justify-center bg-card rounded-2xl z-10">
                      <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
                      <p className="text-muted-foreground text-sm mt-4">Loading form...</p>
                    </div>}
                  {/* Pipedrive form - ALWAYS in DOM */}
                  <div className="pipedriveWebForms" data-pd-webforms="https://webforms.pipedrive.com/f/5VHze7XMkxvbWRM3GCs8e6UJXU6fDSNduPCHckHRSqUUKKNqzQVn8ETxKXuDOsH6in" />
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>;
};
export default BecomePartner;